import dayjs from 'dayjs'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DateTimeInput } from 'semantic-ui-calendar-react'
import { Form } from 'semantic-ui-react'
import { getError } from '~/components/FormFields/util'
import { getDateWithTime, getMinDate } from '~/utils/helpers'
import { StyledErrorLabel } from '../../MilkMoney/MilkDelivery/ShowTours/style'
import { LanguageType } from '~/api/services/auth'

interface Props {
  languageLocal: LanguageType
}

const Dates: React.FC<Props> = ({ languageLocal }) => {
  const { t } = useTranslation()
  const { control, setValue, formState: { isSubmitted } } = useFormContext()

  const watchStartDate = useWatch({ control, name: 'start' })
  const watchEndDate = useWatch({ control, name: 'end' })

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  return <Form.Group widths={'equal'}>
    <Controller
      control={control}
      name={'start'}
      rules={{
        required: {
          value: true,
          message: t('Please enter start date')
        },
        validate: () => {
          const dateFrom = getDateWithTime(watchStartDate)
          const currentDate = getDateWithTime(dayjs(new Date()).format('DD.MM.YYYY HH:mm'))
          if (dateFrom && currentDate && dayjs(dateFrom).diff(dayjs(currentDate)) <= 0) {
            return t('Please select a date ahead of the current date.')
          }
          return true
        }
      }}
      render={({ field, fieldState }) => {
        const dateFrom = watchStartDate ? getDateWithTime(watchStartDate) : ''
        const currentDate = getDateWithTime(dayjs(new Date()).format('DD.MM.YYYY HH:mm'))
        return <Form.Field
          required
          error={!watchStartDate && isSubmitted ? getError(fieldState) : dateFrom && currentDate && dayjs(dateFrom).diff(dayjs(currentDate)) <= 0 ? true : false}
        >
          <label>{t('Start of data collection')}</label>
          <DateTimeInput
            name='dateTime'
            placeholder={t('Start of data collection')}
            minDate={dayjs(new Date()).format('DD.MM.YYYY HH:mm')}
            closable
            onKeyDown={handleKeyPress}
            markColor={'blue'}
            localization={languageLocal.code}
            closeOnMouseLeave={false}
            dateTimeFormat={'DD.MM.YYYY HH:mm'}
            className={'datePicker'}
            value={watchStartDate}
            iconPosition='left'
            onChange={(event, { name, value }) => setValue('start', value)}
          />
          {!watchStartDate && isSubmitted && <StyledErrorLabel className='ui pointing basic label'>{t('Please enter start date')}</StyledErrorLabel>}
          {dateFrom && currentDate && dayjs(dateFrom).diff(dayjs(currentDate)) <= 0 &&
            <StyledErrorLabel className='ui pointing basic label'>{t('Please select a date ahead of the current date.')}</StyledErrorLabel>}
        </Form.Field>

      }}
    />
    <Controller
      control={control}
      name={'end'}
      rules={{
        required: {
          value: true,
          message: t('Please enter end date')
        },
        validate: () => {
          const dateFrom = getDateWithTime(watchStartDate)
          const dateTo = getDateWithTime(watchEndDate)
          if (dateFrom && dateTo && dayjs(dateTo).diff(dayjs(dateFrom)) <= 0) {
            return t('Please select a date ahead of the start date.')
          }
          return true
        }
      }}
      render={({ field, fieldState }) => {
        const dateFrom = getDateWithTime(watchStartDate || '')
        const dateTo = getDateWithTime(watchEndDate || '')
        return <Form.Field
          required
          error={!watchEndDate && isSubmitted ? getError(fieldState) : false}
        >
          <label>{t('End of data collection')}</label>
          <DateTimeInput
            name='dateTime'
            className={'datePicker'}
            placeholder={t('End of data collection')}
            closable
            markColor={'blue'}
            onKeyDown={handleKeyPress}
            onKeyPress={handleKeyPress}
            initialDate={getMinDate(watchStartDate)}
            minDate={getMinDate(watchStartDate)}
            localization={languageLocal.code}
            closeOnMouseLeave={false}
            dateTimeFormat={'DD.MM.YYYY HH:mm'}
            disabled={!watchStartDate}
            value={watchEndDate}
            iconPosition='left'
            onChange={(event, { name, value }) => setValue('end', value)}
          />
          {!watchEndDate && isSubmitted && <StyledErrorLabel className='ui pointing basic label'>{t('Please enter end date')}</StyledErrorLabel>}
          {dateFrom && dateTo && dayjs(dateTo).diff(dayjs(dateFrom)) <= 0 &&
            <StyledErrorLabel className='ui pointing basic label'>{t('Please select a date ahead of the start date.')}</StyledErrorLabel>}
        </Form.Field>
      }}
    />
  </Form.Group>
}
export default Dates